<template>
  <div
    v-if="meetings.length > 0"
    class="tw-max-w-condensed-content tw-flex tw-flex-col tw-gap-4 tw-mx-auto"
  >
    <div v-for="meeting in meetings" :key="meeting.id">
      <MeetingCard :meeting="meeting" @open-meeting-modal="openMeetingModal" />
    </div>

    <CompleteMeetingModal
      v-if="modalData"
      :remark-ids="modalData.remarkIds"
      :meeting-id="modalData.id"
      :title="modalData.title"
      :summary="modalData.summary"
      :date="modalData.completedAt"
      :edit="true"
    />
  </div>
  <PastMeetingsEmpty v-else :talking-point-tag="talkingPointTag" />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick, computed } from 'vue'
import { createPastMeetingsStore } from '@app/application/client_meetings/screens/past-meetings/store/past-meetings-store'
import MeetingCard from './meeting-card.vue'
import PastMeetingsEmpty from './past-meetings-empty.vue'
import CompleteMeetingModal from '@app/application/client_meetings/screens/preparation/components/complete-meeting-modal.vue'
import { useStore } from 'vuex'
import { storeToRefs } from 'pinia'

const pastMeetingsStore = createPastMeetingsStore()
const store = useStore()

const { meetings } = storeToRefs(pastMeetingsStore)

const modalData = ref(null)

const talkingPointTag = computed(() => store.getters.talkingPointTag)

const { fetchPastMeetings } = pastMeetingsStore

async function openMeetingModal(meeting) {
  modalData.value = { ...meeting, remarkIds: meeting.order }

  await nextTick()

  window.modalCitizen.openModalPortal('complete-meeting-modal')
}

async function refreshCommunicationData() {
  await store.dispatch('fetchCommunication')
}

fetchPastMeetings()
refreshCommunicationData()

store.dispatch('fetchMentionUsernames')

onMounted(() => {
  window.eventHub.$on('refreshCommunicationData', refreshCommunicationData)
  window.eventHub.$on('refreshClientMeetings', fetchPastMeetings)
})

onBeforeUnmount(() => {
  window.eventHub.$off('refreshClientMeetings', fetchPastMeetings)
  window.eventHub.$off('refreshCommunicationData', refreshCommunicationData)
})
</script>
